<div fxLayout="row" fxLayoutAlign="start center">
  <div class="image-container">
    <div class="image" fxLayoutAlign="center center" (click)="fileInput.click()">
      <img *ngIf="imageSource" [src]="imageSource | safeURL" alt="" matTooltip="Charger une photo" />
      <mat-icon *ngIf="!imageSource">add_a_photo</mat-icon>
    </div>
  </div>
  <app-button
    [text]="imageSourceNotExists() ? 'Ajouter une photo' : 'Modifier la photo'"
    (click)="fileInput.click()"
    btnType="text"
  ></app-button>
  <input
    #fileInput
    (change)="onFileChangeHandler($event)"
    hidden
    type="file"
    accept="image/png, image/jpg, image/jpeg"
  />
  <app-button
    [disabled]="imageSourceNotExists()"
    [text]="textDelete"
    btnType="text"
    color="danger"
    (click)="onClickDeleteProfilePicture()"
  ></app-button>
</div>
